module.exports = __webpack_public_path__ + "img/replace-battery.c2861a75.svg";